import React from 'react';
import ServiceAreaDetail from '../ServiceAreaDetail';

// Dedicated page component for /service-areas/brooklyn-ny
const BrooklynPage = () => <ServiceAreaDetail slug="brooklyn-ny" />;

export default BrooklynPage;
